export const AFFILIATE_TRANSACTION_STATUS = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  REFUND: 'REFUND',
}

export const AFFILIATE_TRANSACTION_STATUS_TEXT_COLOR = {
  [AFFILIATE_TRANSACTION_STATUS.DEPOSIT]: 'green',
  [AFFILIATE_TRANSACTION_STATUS.WITHDRAW]: 'red',
  [AFFILIATE_TRANSACTION_STATUS.REFUND]: 'red',
}
